import toast from "react-hot-toast";

export const createFieldUpdater = (
  className,
  fieldName,
  selectedRows,
  mutationFn
) => {
  return async (columnInfo, row, editedValue) => {
    let payload = [];

    // Handle both single row and multi-row selections
    if (selectedRows.length < 1 || !row.getIsSelected()) {
      if (row.original.status?.display === "launched") {
        toast.error(`Cannot edit launched ad ${row.original.glid.display}`);
        return;
      }
      payload.push({
        class: className,
        glid: row.original.glid.display,
        update: {
          [fieldName]: editedValue,
        },
      });
    } else if (selectedRows.length >= 1) {
      for (const selectedRow of selectedRows) {
        if (selectedRow.original.status?.display === "launched") {
          toast.error(
            `Cannot edit launched ad ${selectedRow.original.glid.display}`,
            {
              duration: 3000,
            }
          );
          return;
        }
        payload.push({
          class: className,
          glid: selectedRow.original.glid.display,
          update: {
            [fieldName]: editedValue,
          },
        });
      }
    }

    const result = await mutationFn(payload);
    if (result.error) {
      const errorMessage =
        result?.error?.data?.[0]?.response?.error?.message || // from your JSON structure
        result?.error?.data?.[0] ||
        "Something went wrong";
      toast.error(errorMessage);
      return result;
    } else {
      toast.success(
        `${fieldName
          .replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase())} updated successfully`
      );
      return result;
    }
  };
};
